// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const select: Styleguide["select"] = {
    defaultProps: {
        iconProps: { src: ChevronDown },
        css: css`
            /* Store Custom Code - Start */
            cursor: pointer;
            /* Store Custom Code - End */

            &&:not(.selected)[data-selected-index=""] {
                color: ${getColor("placeholder")};

                &:disabled,
                &.disabled {
                    color: ${getColor("placeholder.disabled")};
                }
            }

            option {
                color: ${getColor("text.input")};
                /* Store Custom Code - Start */
                padding: ${pxToRem(10, 15)};
                cursor: inherit;
                /* Store Custom Code - End */

                select:not(.selected) &[value=""] {
                    color: ${getColor("placeholder")};
                }

                &:disabled {
                    background-color: ${x => getColor("common.disabled")};
                    color: ${getColor("text.disabled")};
                }
            }
        `,
    },
};

export default select;
